module.exports = __webpack_public_path__ + "img/bigLuck.aafc92c8.png";